<div class="poa-ior-edit-sidebar" [formGroup]="formGroup">
  <!-- First Name -->
  <div class="poa-ior-edit-sidebar__field">
    <app-control-wrapper [errors]="errors.firstName" [control]="formGroup.get('firstName')" [isShowHelper]="false">
      <label for="sidebarIorFirstName" control-label>
        {{ "LABELS.FIRST_NAME" | translate }}
      </label>
      <input
        type="text"
        formControlName="firstName"
        class="form-control"
        id="sidebarIorFirstName"
        name="sidebarIorFirstName"
        [placeholder]="'LABELS.FIRST_NAME' | translate"
        control-wrapper
        (blur)="trimField('firstName')"
      />
    </app-control-wrapper>
  </div>

  <!-- Last Name -->
  <div class="poa-ior-edit-sidebar__field">
    <app-control-wrapper [errors]="errors.lastName" [control]="formGroup.get('lastName')" [isShowHelper]="false">
      <label for="sidebarIorLastName" control-label>
        {{ "LABELS.LAST_NAME" | translate }}
      </label>
      <input
        type="text"
        formControlName="lastName"
        class="form-control"
        id="sidebarIorLastName"
        name="sidebarIorLastName"
        [placeholder]="'LABELS.LAST_NAME' | translate"
        control-wrapper
        (blur)="trimField('lastName')"
      />
    </app-control-wrapper>
  </div>

  <!-- Phone Number -->
  <div class="poa-ior-edit-sidebar__field">
    <input-phone
      [fc]="formGroup.get('phoneNumber')"
      [errors]="errors.phoneNumber"
      [label]="'COMPANY.IOR.MOBILE_NUMBER'"
      [id]="'sidebarIorPhoneNumber'"
      [isShowHelper]="false"
    ></input-phone>
  </div>

  <!-- Email Address -->
  <div class="poa-ior-edit-sidebar__field">
    <app-control-wrapper [errors]="errors.emailAddress" [control]="formGroup.get('emailAddress')" [isShowHelper]="false">
      <label for="sidebarIorEmailAddress" control-label>
        {{ "LABELS.EMAIL_ADDRESS" | translate }}
      </label>
      <input
        type="email"
        formControlName="emailAddress"
        class="form-control"
        id="sidebarIorEmailAddress"
        name="sidebarIorEmailAddress"
        [placeholder]="'LABELS.EMAIL_ADDRESS' | translate"
        control-wrapper
        (blur)="onEmailBlur()"
      />
    </app-control-wrapper>
  </div>

  <!-- Save Button -->
  <div class="poa-ior-edit-sidebar__actions">
    <button class="btn btn-primary" [disabled]="!isFormValid" (click)="onSave()">
      {{ "BUTTON.SAVE" | translate }}
    </button>
  </div>

  <!-- IOR Match Confirmation Modal (#13060) -->
  <app-ior-match-confirm-modal
    [open]="isMatchConfirmOpen"
    (accept)="onIorMatchAccept()"
    (decline)="onIorMatchDecline()"
  ></app-ior-match-confirm-modal>
</div>
